import { OrganizationResource } from './organization.resource';

import { ApiTypes, StateRecord } from '@mode/shared/contract-common';
import { ModeResourceHelper } from '@mode/shared/util-halogen';

export interface DatasourceResource extends StateRecord, ApiTypes.ModeResource {
  custom_attributes?: any;
  default_access_level?: 'View' | 'Query' | 'None';
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace DatasourceResourceHelper {
  import isResource = ModeResourceHelper.isResource;

  export function getPermissionOptions(resource: DatasourceResource): string[] {
    if (isResource(resource) && resource.hasEmbedded('permissions')) {
      const permissions: ApiTypes.ModeResource = resource.embedded('permissions');
      const permissionsCreateForm = permissions.forms('create');
      const formOptions = permissionsCreateForm._inputs.permission.action.options;

      if (formOptions) {
        return formOptions;
      }
    }

    return [];
  }

  export function getDefaultAccessLevel(
    resource: DatasourceResource,
    organization: OrganizationResource
  ): string | null {
    if (organization.hasLink('everyone_group') && resource.hasEmbedded('permissions')) {
      const everyoneGroupLink = organization.links('everyone_group').href;
      const permissions = resource.embedded('permissions').embedded('data_source_entitlements');
      // entitlement for everyone group
      const defaultEntitlement = permissions.find((permission: any) => everyoneGroupLink.includes(permission.token));

      if (defaultEntitlement) {
        return defaultEntitlement.action;
      }
    }

    return null;
  }
}
